import type { QuickAction } from '../../types/chat';

interface QuickActionChipsProps {
  actions: QuickAction[];
  onActionClick: (text: string) => void;
}

export const QuickActionChips = ({ actions, onActionClick }: QuickActionChipsProps) => {
  console.log('QuickActionChips rendering with actions:', actions.length, actions.map(a => a.text));
  
  if (!actions || actions.length === 0) return null;
  
  return (
    <div className="absolute bottom-20 left-4 right-4 z-10 pointer-events-none">
        <div className="flex gap-1.5 overflow-x-auto custom-scrollbar pb-1" style={{ scrollbarWidth: 'thin' }}>
          {actions.map((action, index) => (
            <button
              key={`${action.text}-${index}`}
              onClick={() => onActionClick(action.text)}
              className="group relative inline-flex items-center gap-1.5 px-2.5 py-1.5 bg-purple-50 hover:bg-[#4c3794] text-[#4c3794] hover:text-white text-xs font-medium rounded-lg border border-purple-200 hover:border-[#4c3794] transition-all duration-200 hover:shadow-md active:scale-95 flex-shrink-0 whitespace-nowrap"
              style={{
                animation: `slideIn 0.3s ease-out ${index * 0.05}s backwards`,
                pointerEvents: 'auto'
              }}
            >
              <span className="relative z-10 flex items-center justify-center w-3 h-3 transition-colors">
                {action.icon}
              </span>
              <span className="relative z-10 leading-tight">{action.text}</span>
            </button>
          ))}
        </div>
     
    </div>
  );
};
